<template>
  <SearchWrapper :record-type="RecordType.Path">
    <AisStateResults>
      <template #default="{ results: { hits, query } }">
        <AisHits v-if="hits.length > 0">
          <template #default="{ items }">
            <div class="grid lg:grid-cols-2 gap-x-8">
              <template
                v-for="item in items"
                :key="item.uuid"
              >
                <div class="mb-8 break-inside-avoid">
                  <PathCard :path="item" />
                </div>
              </template>
            </div>
          </template>
        </AisHits>
        <div
          v-else
          class="py-8 text-center text-gray-800"
        >
          No results have been found
          <template v-if="query">
            for <strong><q>{{ query }}</q></strong>
          </template>
        </div>
        <SearchPagination />
      </template>
    </AisStateResults>
  </SearchWrapper>
</template>

<script lang="ts">
export default { name: 'PathSearch' }
</script>

<script setup lang="ts">
import { AisHits, AisStateResults } from 'vue-instantsearch/vue3/es'

import { RecordType } from '~/types/records/RecordType'

import SearchPagination from '~/components/externalContent/search/SearchPagination.vue'
import SearchWrapper from '~/components/externalContent/search/SearchWrapper.vue'
import PathCard from './PathCard.vue'
</script>
